import { useCallback } from 'react';

export function usePageSelection(setSelectedPages, lastSelectedPage, setLastSelectedPage) {
  const handlePageClick = useCallback((pdfPageNum, e) => {
    if (e.ctrlKey || e.metaKey) {
      setSelectedPages((prev) =>
        prev.includes(pdfPageNum) ? prev.filter((p) => p !== pdfPageNum) : [...prev, pdfPageNum]
      );
      setLastSelectedPage(pdfPageNum);
    } else if (e.shiftKey && lastSelectedPage) {
      const start = Math.min(lastSelectedPage, pdfPageNum);
      const end = Math.max(lastSelectedPage, pdfPageNum);
      const range = Array.from({ length: end - start + 1 }, (_, i) => start + i);
      setSelectedPages(range);
    } else {
      setSelectedPages([pdfPageNum]);
      setLastSelectedPage(pdfPageNum);
    }
  }, [lastSelectedPage, setSelectedPages, setLastSelectedPage]);

  return { handlePageClick };
}
